export default "__VITE_ASSET__D4T8zNLH__"